<template>
    <div class="kgk-teamless">
        <CreateTeam @created="$emit('triggerReload')" />

        <div class="spacer"></div>

        <UserInvitesList @accepted="$emit('triggerReload')" @declined="$emit('triggerReload')" />
    </div>
</template>

<script>
    import CreateTeam from './CreateTeam';
    import UserInvitesList from './UserInvitesList';

    export default {
        name: 'Teamless',
        components: {
            CreateTeam,
            UserInvitesList,
        },
        props: {
            //msg: String
        },
        data() {
            return {

            }
        },
        computed: {
            /*totalLength: function() {
                return this.runs.reduce((total, run) => total + run.length, 0);
            },
            totalDuration: function() {
                return this.runs.reduce((total, run) => total + run.duration, 0);
            },
            averagePace: function() {
                return this.totalDuration / this.totalLength;
            },*/
        },
        mounted() {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped lang="scss">
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
</style>-->
